import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthDispatch, useAuthState } from "../context/AuthContext";

const ProtectedRoute = (props) => {
  const { user } = useAuthState();

  console.log(user);
  if (!user){
    return <Navigate to="/login" replace/>
  }

  if (!user.is_admin && props.isAdmin){
    return <Navigate to="/dashboard" replace/>
  }

  return props.children ? props.children : <Outlet/>
}

export default ProtectedRoute;